import { render } from "./SelectList.vue?vue&type=template&id=70b516d2&ts=true"
import script from "./SelectList.vue?vue&type=script&lang=ts"
export * from "./SelectList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__